import { ReactNode } from 'react';
import { Header } from '../../components/organisms/Header/Header';
import { PageView } from '../../models/analytics';

export type TemplateViewContainerProps = {
  onGoBack: () => void;
  children: ReactNode;
};

export const TemplateViewContainer: React.FC<TemplateViewContainerProps> = ({
  onGoBack,
  children,
}) => {
  return (
    <>
      <Header
        onBack={onGoBack}
        addBottomMargin={false}
        pageView={PageView.SUPPLEMENTAL_INFORMATION_SCREEN}
      />
      {children}
    </>
  );
};
